module.exports = __webpack_public_path__ + "202408221624/img/icon_create_1.208621dd.png";